import Calendar from 'apollo-react-icons/Calendar';
import ChartBar from 'apollo-react-icons/ChartBar';
import ClipboardSearch from 'apollo-react-icons/ClipboardSearch';
import Clock from 'apollo-react-icons/Clock';
import Cog from 'apollo-react-icons/Cog';
import Dashboard from 'apollo-react-icons/Dashboard';
import Download from 'apollo-react-icons/Download';
import FileDocuments from 'apollo-react-icons/FileDocuments';
import GantList from 'apollo-react-icons/GantList';
import Key from 'apollo-react-icons/Key';
import Link from 'apollo-react-icons/Link';
import Plus from 'apollo-react-icons/Plus';
import StarSolid from 'apollo-react-icons/StarSolid';
import _ from 'lodash';

import { isTrue } from './commonUtils';
import { set } from './ramdaUtils';
import RepositoryIcon from '../assets/icons/react/Repository';
import FindIcon from '../assets/icons/react/SavedSearch';
import { ARCHIVED_MODE_MENU_ITEMS } from '../constants/NavigationConstants';
import { POWERBI_ENABLED_APP_SETTING, POWERBI_ENTITY_NAME } from '../constants/PowerBIConstants';
import { FORMS_DESIGN_RIGHT } from '../form-designer/constants/editor.constants';

const iconsArray = [
  { dashboardIcon: Dashboard },
  { recentIcon: Clock },
  { favoritesIcon: StarSolid },
  { createIcon: Plus },
  { findIcon: FindIcon },
  { reportsIcon: ChartBar },
  { repositoryIcon: RepositoryIcon },
  { calendarIcon: Calendar },
  { monitoring: Link },
  // {onGoingMaintenanceIcon: onGoingMaintenanceIcon}, // TODO: uncomment onGoingMaintenanceIcon when icon is provided
  { setupIcon: Key },
  { settingsIcon: Cog },
  { savedSearches: ClipboardSearch },
  { reportIcon: FileDocuments },
  { reportModels: GantList },
  { exportIcon: Download },
  { importIcon: Download },
  { historyIcon: Clock },
];

export function getNavsideIcon(iconStr) {
  const navSideIcon = iconsArray
    .filter((elem) => !!elem[iconStr]) //
    .reduce((acc, val) => val[iconStr], Plus);
  return navSideIcon;
}

export const getSelectedNavLink = (navigation, selectedEntity = {}) => {
  let navLink = undefined;
  const { entityName, searchName } = selectedEntity;

  //Find the link object for the currently selected entity being displayed
  if (Array.isArray(navigation)) {
    navigation.forEach((navItem) => {
      const templateData = navItem?.contentInfos?.menu?.contentData?.templateData;
      if (Array.isArray(templateData)) {
        templateData.forEach((data) => {
          const links = data?.Links;
          if (Array.isArray(links)) {
            const navLinkInternal = links.find((link) =>
              searchName
                ? link.EntityName === entityName && link.SavedSearchName === searchName
                : link.EntityName === entityName
            );
            if (navLinkInternal) {
              navLink = navLinkInternal;
            }
          }
        });
      }
    });
  }

  return navLink;
};

export const shouldSkipRootMenuItem = (rootNavigationItem, { isArchiveMode, appSettings }) => {
  const shouldSkipArchiveMenuItem =
    isArchiveMode && !ARCHIVED_MODE_MENU_ITEMS.includes(rootNavigationItem.Id);
  const shouldSkipPowerBIMenuItem =
    rootNavigationItem?.Id === 'PowerBIReports' &&
    !isTrue(appSettings[POWERBI_ENABLED_APP_SETTING]);

  return shouldSkipArchiveMenuItem || shouldSkipPowerBIMenuItem;
};

const filterProtectedLinks = (links, userRights, appSettings) =>
  links.filter((link) => {
    const isFormEditorLinkProtected =
      link.ID === 'FormsEditor' && !userRights.includes(FORMS_DESIGN_RIGHT);

    const isPowerBILinkProtected =
      link.EntityName === POWERBI_ENTITY_NAME && !isTrue(appSettings[POWERBI_ENABLED_APP_SETTING]);

    return !isFormEditorLinkProtected && !isPowerBILinkProtected;
  });

//filter out protected links from ADMIN_NAVIGATION_ITEMS,
//if user does not have corresponding Right or AppSetting enabled for a specific feature (e.g. FormsEditor, PowerBI)
export const getFilteredNavigationLink = (navigationItem, { userRights, appSettings }) => {
  const templateData = _.get(navigationItem, 'contentInfos.menu.contentData.templateData', []);

  const filteredItems = templateData.map((templateDataItem) => ({
    ...templateDataItem,
    Links: filterProtectedLinks(templateDataItem.Links, userRights, appSettings),
  }));

  return set(
    navigationItem,
    ['contentInfos', 'menu', 'contentData', 'templateData'],
    filteredItems
  );
};
